$(document).ready(function () {
    $(".main-slider").owlCarousel({
        items: 1,
        autoHeight: true,
        loop: false,
        autoplay: true,
        autoplaySpeed: 1500,
        animateOut: "fadeOut",
        animateIn: "fadeIn",
        dots: false,
    });


    
});
